import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import SpendCubeChart from '../DataAnalysis/SpendCubeChart';

interface SankeyDiagramProps {
  categories?: any[];
}

const SankeyDiagram: React.FC<SankeyDiagramProps> = ({ categories }) => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    // Generate mock data for the sankey diagram if categories are not provided
    const generateMockData = () => {
      // Mock data for the supplier consolidation sankey diagram
      // This will be replaced by actual data from the categories prop in a real implementation
      const mockData = [
        // IT Services
        { 
          itemId: 'IT001', 
          description: 'IT Services - TechCorp', 
          supplier: 'TechCorp', 
          amount: 3500000, 
          category: 'IT Services',
          businessUnit: 'Operations'
        },
        { 
          itemId: 'IT002', 
          description: 'IT Services - IT Solutions Inc', 
          supplier: 'IT Solutions Inc', 
          amount: 2800000, 
          category: 'IT Services',
          businessUnit: 'Sales'
        },
        { 
          itemId: 'IT003', 
          description: 'IT Services - Digital Consulting', 
          supplier: 'Digital Consulting', 
          amount: 2200000, 
          category: 'IT Services',
          businessUnit: 'Marketing'
        },
        { 
          itemId: 'IT004', 
          description: 'IT Services - InfraSupport Co', 
          supplier: 'InfraSupport Co', 
          amount: 1900000, 
          category: 'IT Services',
          businessUnit: 'Finance'
        },
        { 
          itemId: 'IT005', 
          description: 'IT Services - CloudTech Solutions', 
          supplier: 'CloudTech Solutions', 
          amount: 1400000, 
          category: 'IT Services',
          businessUnit: 'HR'
        },
        { 
          itemId: 'IT006', 
          description: 'IT Services - Various IT Vendors', 
          supplier: 'Various IT Vendors', 
          amount: 700000, 
          category: 'IT Services',
          businessUnit: 'Operations'
        },
        
        // Office Supplies
        { 
          itemId: 'OS001', 
          description: 'Office Supplies - Office Depot', 
          supplier: 'Office Depot', 
          amount: 3200000, 
          category: 'Office Supplies',
          businessUnit: 'Operations'
        },
        { 
          itemId: 'OS002', 
          description: 'Office Supplies - Staples', 
          supplier: 'Staples', 
          amount: 800000, 
          category: 'Office Supplies',
          businessUnit: 'Sales'
        },
        { 
          itemId: 'OS003', 
          description: 'Office Supplies - Various Local Suppliers', 
          supplier: 'Various Local Suppliers', 
          amount: 300000, 
          category: 'Office Supplies',
          businessUnit: 'Marketing'
        },
        
        // Marketing Services
        { 
          itemId: 'MS001', 
          description: 'Marketing Services - Global Marketing Inc', 
          supplier: 'Global Marketing Inc', 
          amount: 3900000, 
          category: 'Marketing Services',
          businessUnit: 'Marketing'
        },
        { 
          itemId: 'MS002', 
          description: 'Marketing Services - Various Marketing Vendors', 
          supplier: 'Various Marketing Vendors', 
          amount: 300000, 
          category: 'Marketing Services',
          businessUnit: 'Sales'
        },
        
        // Logistics
        { 
          itemId: 'LG001', 
          description: 'Logistics - ShipFast', 
          supplier: 'ShipFast', 
          amount: 1600000, 
          category: 'Logistics',
          businessUnit: 'Operations'
        },
        { 
          itemId: 'LG002', 
          description: 'Logistics - Global Logistics', 
          supplier: 'Global Logistics', 
          amount: 1400000, 
          category: 'Logistics',
          businessUnit: 'Sales'
        },
        { 
          itemId: 'LG003', 
          description: 'Logistics - QuickShip', 
          supplier: 'QuickShip', 
          amount: 1200000, 
          category: 'Logistics',
          businessUnit: 'Marketing'
        },
        { 
          itemId: 'LG004', 
          description: 'Logistics - Regional Transporters', 
          supplier: 'Regional Transporters', 
          amount: 700000, 
          category: 'Logistics',
          businessUnit: 'Finance'
        },
        { 
          itemId: 'LG005', 
          description: 'Logistics - Express Delivery', 
          supplier: 'Express Delivery', 
          amount: 500000, 
          category: 'Logistics',
          businessUnit: 'HR'
        }
      ];
      
      return mockData;
    };

    // Set data immediately
    setData(generateMockData());
  }, []);

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        This Sankey diagram visualizes spend flow from suppliers to categories to business units, 
        highlighting fragmented spending patterns that may represent consolidation opportunities.
      </Typography>
      <Box sx={{ height: 'calc(100% - 60px)', minHeight: '500px' }}>
        <SpendCubeChart data={data} />
      </Box>
    </Box>
  );
};

export default SankeyDiagram; 